module.exports = __webpack_public_path__ + "img/chevron-up.edcb4264.svg";